







































































































































































































































































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';
import { RobotOption, TwitterCardOption } from '@/models/MetaTags';
import { BrandQueryResultItem, User, MonitoringsService, Monitoring } from '@/api/braendz';
import { getLocalesString, Locale, findLocale, locales } from '@/models/Locale';
import { BusyList, BusyObject } from '@/models/Busy';
import { AgentExecutionFrequency } from '@/models/AgentExecutionFrequency';
import { createQueryByBrand } from '@/logic/Monitoring';

import LoadingView from '@/components/Spinner/LoadingView.vue';
import BrandPicker from '@/components/Brands/BrandPicker.vue';
import VerticalBrandTile from '@/components/Brands/VerticalBrandTile.vue';
import BrandDetailsButton from '@/components/Brands/BrandDetailsButton.vue';
import BookmarkBrandButton from '@/components/BrandBookmarks/BookmarkBrandButton.vue';
import MonitorBrandButton from '@/components/Monitoring/MonitorBrandButton.vue';


@Component({
  components: {
    LoadingView,
    BrandPicker,
    VerticalBrandTile,
    BrandDetailsButton,
    BookmarkBrandButton,
    MonitorBrandButton
  },
  metaInfo() {
    return {
      title: this.$i18n.t("monitorBrand.title").toString(),
      meta: [
        { name: 'robots', content: [RobotOption.NoIndex, RobotOption.NoFollow].join(',') },

        // Open Graph: Facebook, Instagram, WhatsApp, LinkedIn, Xing, Twitter:
        { property: 'og:type', content: "website" },
        { property: 'og:title', content: this.$i18n.t("monitorBrand.metaTags.title").toString() },
        { property: 'og:description', content: this.$i18n.t("monitorBrand.metaTags.description").toString() },
        { property: 'og:image', content: `${window.location.origin}${require('@/assets/logos/braendz-logo-tm-blue.png')}` },
        { property: 'og:locale', content: this.$i18n.locale },
        { property: 'og:locale:alternate', content: getLocalesString(',') },
        { property: 'og:site_name', content: this.$i18n.t("metaTags.title").toString()},

        // Twitter:
        { property: 'twitter:card', content: TwitterCardOption.SummaryLargeImage },
        { property: 'twitter:site', content: `@${process.env.VUE_APP_TWITTER_ACCOUNT}` }
      ]
    };
  }
})
export default class CreateBrandMonitoring extends Vue {
    // Private Fields:
    private m_mailingTo: string | null = null;

    // Public Fields:
    public isFormValid = false;
    public selectedTab = 0;
    public createdMonitoring = new BusyObject<Monitoring>();

    public selectedBrand: BrandQueryResultItem | null = null;
    public name: string | null = null;
    public description: string | null = null;
    public executionFrequency: AgentExecutionFrequency | null = null;

    public mailingEnabled = false;
    public mailingCc: string[] = [];
    public mailingCcListItems: string[] = [];
    public mailingCulture: Locale | null = null;
    public mailingOnlyOnChange = false;

    public resultSize = 10;
    public resultSizes = [ 10, 25, 50 ];

    public searchOnlyNewBrands = false;
    public minNameSimilarityScore = 0.7;
    public minLogoSimilarityScore = 0.9;

    // Properties

    // Getter:
    public get isInitializing(): boolean {
        return this.$store.state.activeSubscription.isBusy;
    }

    public get userMailAddress(): string | null {
        return (this.$store.state.user as BusyObject<User>)?.object?.mailAddress ?? null;
    }

    public get locales(): Locale[] {
        return locales;
    }

    public get mailingTo(): string | null {
        return this.m_mailingTo ?? this.userMailAddress;
    }
    public set mailingTo(value: string | null) {
        this.m_mailingTo = value;
    }
    
    // Watchers & Event Handlers:

    // Component Lifecycle

    // Methods
    public removeCcItem(item: string) {
        const itemIndex = this.mailingCc.indexOf(item);
        if (itemIndex >= 0) this.mailingCc.splice(itemIndex, 1);
    }

    public validateMailAddresses(values: []): true | string {
        return values.length <= 0 
            ? true 
            : !values.find(m => this.$validation.mail(m, '') !== true);
    }

    public async create(): Promise<void> {
        if (!((this.$refs.form as Vue & { validate: () => boolean }).validate())) {
            return;
        }

        await this.createdMonitoring.create(async () => {
            if (!this.selectedBrand?.indexItem?.brandId) {
                throw new Error('No valid brand selected.');
            }

            const query = await createQueryByBrand(
                this.selectedBrand, 
                this.resultSize, 
                this.minNameSimilarityScore, 
                this.minLogoSimilarityScore, 
                undefined, // Specific registration office codes
                this.searchOnlyNewBrands, 
                undefined, // Excluded brand IDs
                undefined  // Ignored brand IDs
            );
            
            const monitoring = {
                name: this.name,
                description: this.description,
                brandId: this.selectedBrand.indexItem.brandId,
                settings: { query: query },
                executionFrequency: this.executionFrequency,
                mailingEnabled: this.mailingEnabled,
                mailingTo: this.mailingTo,
                mailingCc: this.mailingCc,
                mailingCulture: this.mailingCulture?.locale,
                mailingOnlyOnChange: this.mailingOnlyOnChange
            } as Monitoring;

            return await MonitoringsService.upsertMonitoringCurrentUserDefaultAccount(monitoring);
        });

        this.$router.push({name: 'Monitorings', params: { lang: this.$i18n.locale }});
    }
}
